import {Three as THREE, ThreeTsl as TSL} from "@cm/material-nodes/three"
import {asVec3} from "@cm/material-nodes"

export class OutputRenderPass extends THREE.TempNode<"vec4"> {
    constructor(private input: THREE.Node<"vec4">) {
        super("vec4")
    }

    override dispose() {}

    override setup() {
        const {rgb, a} = this.input
        const texel = asVec3(TSL.sRGBTransferOETF(rgb.div(a)))
        return TSL.vec4(texel.mul(a), a)
    }
}
